import script from "./StepCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./StepCreate.vue?vue&type=script&setup=true&lang=js"

import "./StepCreate.vue?vue&type=style&index=0&id=f1b7b530&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1b7b530"]])

export default __exports__